import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ProtectedRoute from '../../components/auth/ProtectedRoute';
import {
  Container,
  Title,
  Alert,
  Text
} from '@mantine/core';
import { IconExclamationCircle } from '@tabler/icons-react';
import SpecialRequestsList from '../../components/special-requests/SpecialRequestsList';

const SpecialRequestsPage = () => {
  const { user } = useSelector(state => state.auth);
  const navigate = useNavigate();

  // Check if user is a princess (seller)
  if (!user?.is_seller) {
    return (
      <ProtectedRoute requireAuth={true} redirectTo="/">
        <Container size="lg" py="xl">
          <Alert 
            icon={<IconExclamationCircle size="1rem" />} 
            color="red" 
            title="Access Denied"
          >
            <Text>
              This page is only accessible to verified princesses.
            </Text>
          </Alert>
        </Container>
      </ProtectedRoute>
    );
  }

  return (
    <ProtectedRoute requireAuth={true} redirectTo="/">
      <Container size="lg" py="xl">
        <Title order={1} mb="xl">Special Requests</Title>
        <SpecialRequestsList isPrincess={true} />
      </Container>
    </ProtectedRoute>
  );
};

export default SpecialRequestsPage;